import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    dropzoneLabel: {
      textAlign: 'center',

      '& > span': {
        display: 'block',
        color: theme.palette.secondary.main,
      },
    },
  }),
)
